<template>
  <div id="outDiv" style="background-color:#161823;overflow-x:hidden;user-select: none;">
    <div v-show="!showDownload" class="main flex-column">

      <div id="videoDiv" class="videoDiv flex-column" v-if="materialType == 1">
        <div v-if="urlList && urlList.length === 1">
          <img class="designImage" :src="materialUrl">
        </div>
        <Swiper v-else :data="urlList"/>

      </div>

      <div id="videoDiv" class="videoDiv flex-column" v-bind:style="{height:videoDivHeight+'px'}" v-if="materialType == 2">
        <video id="video" class="video" :src="materialUrl" @loadedmetadata="videoLoad" v-bind:style="{width: '100%', left:videoLeft+'px'}"
               preload="auto" loop="loop"
               :wdith="videoWidth+'px'"
               :height="videoHeight+'px'"
               v-bind:poster="posterImage"
               x-webkit-airplay="allow"
               webkit-playsinline='true'
               x5-video-player-type='h5'
               playsinline="true"
               x5-playsinline="true"
               x5-video-orientation="portraint"
               @click="playVideo">
        </video>
        <div class="mogolia" @click="playVideo" v-bind:style="{height:mogoliadHeight+'px'}"></div>
        <div class="playBtn" @click.stop="playVideo">
          <img v-show="!playing" class="play" id="playinglogo" src="../assets/img/play@2x.png" alt="" />
        </div>
      </div>


      <div class="recommend flex-column">
        <div class="title">—&nbsp;热门推荐&nbsp;—</div>
        <div class="content">
          <waterfall :col='col' :data="dataList" @loadmore="loadmore">
            <div v-show="item.templateId != nowMaterialId" class="cell-item" :width="itemWidth" :gutterWidth="gutterWidth" v-bind:key="item.templateId" v-for="item in dataList" @click="playRecommend(item.rootTemplateId)">
              <img :id="'image_'+item.templateId" style="width:100%;;border-radius: 5px" :src="item.imgUrl" alt="加载错误" />
              <!--                            <video  :id="'video_'+item.materialId"  class="video"  :src="item.materialUrl"-->
              <!--                                   preload="auto"  x-webkit-airplay="allow"-->
              <!--                                   :poster="item.previewImageUrl"-->
              <!--                                   webkit-playsinline='true'-->
              <!--                                   x5-video-player-type='h5'-->
              <!--                                   playsinline="true"-->
              <!--                                   x5-playsinline="true"-->
              <!--                                   x5-video-orientation="portraint" >-->
              <!--                            </video>-->
            </div>
          </waterfall>
        </div>
        <div class="title" v-show="!hasNextPage">没有更多</div>
      </div>
    </div>


    <div v-show="!showDownload" id="footer" class="foot flex-row">
      <img class="logo" src="../assets/img/design/logo.png" />
      <div class="text ">
        <div class="appname">青柠设计</div>
        <div class="desc">五分钟做好设计</div>
      </div>
      <div class="button" @click="download()">
        开始设计
      </div>

      <transition name="el-fade-in">
        <div class="transition-box more" v-show="showMore">
          <img src="../assets/img/more@2x.png" />
          <!--            <div class="txt">上滑查看更多</div>-->
        </div>
      </transition>
    </div>


    <download v-show="showDownload"/>
  </div>
</template>

<script>
    import Swiper from '@/components/swiper/index'
    import requestService from "../service/request";
    import Download from "../components/download";
    import {browser} from '@/helper/browser'
    export default {
        name: "Share",
      components: {
        Download,
        Swiper
      },
        data() {
            return {
                urlList: [],
                playing: false,
                materialType: 1,
                materialUrl: "",
                nowMaterialId: 0,
                // previewImageUrl:"",
                obscureImage: "",
                posterImage: "",
                dataList: [],
                page: 1,
                fetchDataList: [],
                col: 2,
                hasNextPage: true,
                videoDivHeight: 0,
                videoDivWidth: 0,
                videoWidth: 0,
                videoHeight: 0,
                videoTop: 0,
                videoLeft: 0,
                mogoliadHeight: 0,
                phoneHeight: 0,
                imgHeight: 0,

                loadingPageList: false,
                showMore: true,

                ossBigImgWidth: 720,
                ossSmallImgWidth: 360,

                wxAppId: "wxb2d701dd18160619",
                versionCode: 100,
                showDownload: false
            }
        },
        created() {
            let materialId = this.$route.query.materialId;
            let path = this.$route.path;
            this.nowMaterialId = materialId;
            let type = this.$route.query.type;
            this.type = type;

            if (this.isWeiXin()) {
                // 原始的分享链接
                let originalUrl = document.location.origin + document.location.pathname + "?materialId=" + materialId + "&type=" + type;

                // 分享逻辑
                let action = this.$route.query.action;
                let allowAuth = this.$route.query.allowAuth;
                if (action == 'share' && allowAuth == 1) {
                    let shareUserId = this.$route.query.userId;
                    let redirectUrl = encodeURIComponent(originalUrl);
                    let wxAuthorizeLink = "https://open.weixin.qq.com/connect/oauth2/authorize?appid=" + this.wxAppId + "&redirect_uri=" + redirectUrl + "&response_type=code&scope=snsapi_userinfo&state=" + shareUserId + "#wechat_redirect";
                    document.location.href = wxAuthorizeLink;
                    return;
                }

                // 拿到code之后，就可以到后台后去获取accessToken以及openid
                let code = this.$route.query.code;
                if (code) {
                    let data = new FormData();
                    data.append("code", code);
                    data.append("userId", this.$route.query.state);
                    requestService.sjm.acceptInvite(data).then(res => {
                        let data = res.data;
                        if (res.data.status === 200) {
                            console.log(data);
                        }
                    });
                }
            }

            if (window.screen.width >= 375) {
                this.ossBigImgWidth = 1080;
                this.ossSmallImgWidth = 540;
            }
            else {
                this.ossBigImgWidth = 720;
                this.ossSmallImgWidth = 360;
            }

            requestService.sjm.getMaterial(materialId, type).then(res => {
                let data = res.data;
                if (data.ret === 0) {
                    let item = data.result;
                    this.materialType = item.type;
                    if (item.type === 1) {
                      this.urlList = item.itemList.map(child => {
                        return {
                          url: child.imgUrl + "?x-oss-process=image/resize,m_fixed,w_" + this.ossBigImgWidth + "/quality,q_80"
                        }
                      })
                        this.materialUrl = this.urlList[0].url
                    }
                    if (item.type === 2) {
                        this.materialUrl = item.itemList[0].videoUrl;
                        this.obscureImage = item.itemList[0].videoUrl + "?x-oss-process=video/snapshot,t_0,w_100";
                        this.posterImage = item.itemList[0].videoUrl + "?x-oss-process=video/snapshot,t_0";
                        // this.posterImage = item.previewImgUrl;
                    }

                    // 上传统计
                    if (window._czc) {
                        window._czc.push(['_trackEvent', '设计', '分享', materialId, 1, '']);
                        window._czc.push(['_trackPageview', path, "https://share.qingning6.com/designShare"]);
                    }
                }
            });

            const { versionCode } = this.$route.query
            this.versionCode = parseInt(versionCode) || sessionStorage.getItem('versionCode') || 100
            sessionStorage.setItem('versionCode', versionCode)
        },
        // components: { waterfall },
        mounted() {
            let height = document.documentElement.clientHeight || document.body.clientHeight;
            let footerHeight = document.getElementById('footer').clientHeight;
            this.videoDivHeight = height - footerHeight;
            this.videoDivWidth = document.getElementById('videoDiv').clientWidth;
            this.mogoliadHeight = (this.videoDivHeight / 3).toFixed(0);
            this.phoneHeight = (this.videoDivHeight / 7).toFixed(0);

            this.imgHeight = (this.videoDivWidth / 2 * 16 / 9).toFixed(0);

            if (this.materialType == 2) {
                this.initVideo();
            }
            this.fetchData();
            this.bindScroll();
        },
        computed: {
            itemWidth() {
                return (138 * 0.5 * (document.documentElement.clientWidth / 375));
            },
            gutterWidth() {
                return (9 * 0.5 * (document.documentElement.clientWidth / 375));
            },
            isAppBrowser () {
              let temp = browser();
              return temp === 'weixin' || temp === 'qq' || temp === 'weibo' || temp
            }
        },
        methods: {
            initVideo() {
                let showvideo = document.getElementById('video');
                showvideo.addEventListener('play', function () {
                    this.playing = true;
                    document.getElementById('playinglogo').style.display = "none";
                    document.getElementById('outDiv').style.overflowX = "hidden";
                });
                showvideo.addEventListener('pause', function () {
                    this.playing = false;
                    document.getElementById('playinglogo').style.display = "block";
                    document.getElementById('outDiv').style.overflowX = "hidden";
                });
            },
            videoLoad() {
                let showvideo = document.getElementById('video');
                let videoHeight = showvideo.videoHeight;
                let videoWidth = showvideo.videoWidth;
                let videoDivScale = parseFloat(this.videoDivWidth / this.videoDivHeight).toFixed(2);
                let videoScale = parseFloat(videoWidth / videoHeight).toFixed(2);
                if (videoDivScale > videoScale) {
                    let videoRealHeight = (videoHeight * (this.videoDivWidth / videoWidth)).toFixed(0);
                    this.videoTop = -((videoRealHeight - this.videoDivHeight) / 2).toFixed(0);
                    this.videoWidth = this.videoDivWidth;
                    this.videoHeight = videoRealHeight;
                }
                else if (videoDivScale < videoScale) {
                    let videoRealWidth = (videoWidth * (this.videoDivHeight / videoHeight)).toFixed(0);
                    this.videoLeft = -((videoRealWidth - this.videoDivWidth) / 2).toFixed(0);
                    this.videoHeight = this.videoDivHeight;
                    this.videoWidth = videoRealWidth;
                }
                else {
                    this.videoWidth = this.videoDivWidth;
                    this.videoHeight = this.videoDivHeight;
                }
            },
            download() {
                if (this.judgeClient() === 'PC') {
                    window.location.href = "https://qingning6.com";
                    return
                }
                if (this.isAppBrowser || this.judgeClient() === 'iOS') {
                  window.location.href = "https://a.app.qq.com/o/simple.jsp?pkgname=com.biku.design";
                  return
                }
                if (this.judgeClient() === 'Android' && this.versionCode >= 180) {
                  this.showDownload = true
                  this.openApp()
                  return
                }
                window.location.href = "https://a.app.qq.com/o/simple.jsp?pkgname=com.biku.design";
            },
            openApp() {
              if (this.judgeClient() === 'Android' && this.versionCode >= 180) {
                const url = Number(this.type) === 1 ? `bkdesign://type=template&id=${this.nowMaterialId}` : `bkdesign://type=works&id=${this.nowMaterialId}`
                window.location.href = url
                return
              }
            },
            playRecommend(materialId) {
                document.location.href = "/designShare?materialId=" + materialId + "&type=1";
            },
            obscureImageLoad() {
                let showvideo = document.getElementById('video');
                if (showvideo.poster == "" || showvideo.poster == undefined || showvideo.poster == null) {
                    showvideo.setAttribute("poster", this.obscureImage);
                }
            },
            posterImageLoad() {
                let showvideo = document.getElementById('video');
                showvideo.setAttribute("poster", this.posterImage);
            },
            play: function () {
                this.playing = true;
            },
            pause: function () {
                this.playing = false;
            },
            hrefToShare: function (id) {
                window.location.href = "/share?materialId=" + id + "&recommend=true";
            },
            playVideo: function () {
                let showvideo = document.getElementById('video');
                if (showvideo.paused) {
                    //暂停中
                    showvideo.play();
                    this.playing = true;
                }
                else {
                    showvideo.pause();
                    this.playing = false;
                }
            },
            fetchData() {
                if (this.loadingPageList) return;
                this.loadingPageList = true;
                if (this.hasNextPage) {
                    requestService.sjm.getRecommendList(this.nowMaterialId, this.type, this.page).then(res => {
                        let data = res.data;
                        data.result.list.forEach(item => {
                            item.imgUrl = item.imgUrl + "?x-oss-process=image/resize,m_fixed,w_" + this.ossSmallImgWidth + "/quality,q_80";
                            this.dataList.push(item);
                        });
                        this.hasNextPage = data.result.pageInfo.hasNextPage;
                        this.page++;
                        this.loadingPageList = false;
                    })
                }

            },
            loadmore() {
                if (this.hasNextPage) {
                    this.fetchData();
                }
            },
            bindScroll() {
                document.addEventListener('scroll', this.handleScroll, true);
            },
            handleScroll() {
                if (window.pageYOffset < 100) {
                    this.showMore = true;
                }
                else {
                    this.showMore = false;
                }
            },

            isWeiXin() {
                var ua = window.navigator.userAgent.toLowerCase();
                // ua.indexOf('micromessenger')为真-微信端，如果为假，就是其他浏览器
                if (ua.indexOf('micromessenger') > -1) {
                    return true; // 是微信端
                }
                else {
                    return false;
                }
            },
            judgeClient() {
                let client = ''
                if (/(iPhone|iPad|iPod|iOS)/i.test(window.navigator.userAgent) || (/ QQ/i.test(navigator.userAgent) && /(iPhone|iPad|iPod|iOS)/i.test(window.navigator.userAgent)) || !!navigator.userAgent.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/)) {  //判断iPhone|iPad|iPod|iOS
                    client = 'iOS'
                }
                else if (/(Android)/i.test(window.navigator.userAgent)) {  //判断Android
                    client = 'Android'
                }
                else {
                    client = 'PC'
                }
                return client
            },
        }
    }
</script>

<style scoped lang="less">

  img {
    pointer-events: none;
  }

  .flex-column {
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .flex-row {
    display: flex;
    flex-direction: row;
    align-items: center;
  }

  .video {
    z-index: 1;
    position: absolute;
  }

  .designImage {
    width: 100%;
  }

  .main {
    position: relative;
    background-color: #161823;
    /*width:100%;*/
    /*top:0;*/
    /*left:0;*/
    /*overflow: hidden;*/

    .videoDiv {
      position: relative;
      width: 100%;
      padding: 0;
      margin: 0;
    }

    .head {
      z-index: 999;
      position: absolute;
      top: 4rem;
      /*font-size: 38px;*/
      color: #ffffff;
      font-size: 2.5rem;
      font-weight: normal;
      font-stretch: normal;
      box-shadow: 0rem 0rem 0rem 0rem rgba(112, 112, 112, 0.8);

    }

    .playBtn {
      z-index: 999;
      position: absolute;
      top: 40%;

      .play {
        width: 55px;
      }
    }

    .phone {
      z-index: 999;
      position: absolute;
      bottom: 5rem;

      .accept {
        .logo {
          width: 66px;
        }
      }

      .refuse {
        .logo {
          width: 66px;
        }

        margin-right: 120px;
      }

      .text {
        color: #fefefe;
        font-size: 19px;
        text-align: center;
        margin-top: 10px
      }
    }

    .mogolia {
      z-index: 997;
      /*width: 100%;*/
      /*height: 200px;*/
      /*background-image: linear-gradient(to top, #000000 0%, rgba(68, 68, 68, 0.33) 67%, #878787 100%);*/
      /*opacity: 0.4;*/
      position: absolute;
      height: 14rem;
      width: 100%;
      bottom: 0;
      background: linear-gradient(to top, rgba(0, 0, 0, 0.6), rgba(0, 0, 0, 0));
    }
  }

  .foot {
    z-index: 998;
    position: fixed;
    height: 5%;
    bottom: 0;
    width: 100%;
    padding-top: 12px;
    padding-bottom: 12px;
    background-color: #0e1017;

    .logo {
      width: 41px;
      margin-left: 14px;
      border-radius: 5px;
    }

    .text {
      margin-left: 10px;

      .appname {
        color: #ffffff;
        font-size: 18px;
      }

      .desc {
        color: #b2b2b2;
        font-size: 15px;
      }
    }

    .button {
      position: absolute;
      right: 30px;
      color: #ffffff;
      font-size: 17px;
      width: 88px;
      height: 33px;
      text-align: center;
      line-height: 30px;
      background-image: linear-gradient(-40deg,
      #1c8d52 0%,
      #3abb79 100%);
      border-radius: 33px;
    }

    .more {
      position: absolute;
      left: 50%;
      transform: translate(-50%);
      top: -54px;
      text-align: center;

      img {
        width: 35px;
      }

      .txt {
        font-family: PingFangSC-Regular;
        font-size: 18px;
        font-weight: normal;
        font-stretch: normal;
        line-height: 40px;
        letter-spacing: 0px;
        color: #ffffff;
      }
    }
  }

  .recommend {
    z-index: 997;
    position: relative;

    background-color: #161823;

    .title {
      padding-top: 22px;
      text-align: center;
      width: 100%;
      font-size: 16px;
      color: #b2b2b2
    }

    .content {
      margin-top: 22px;

      .cell-item {
        width: 95%;
        margin: 2px;
        border-radius: 5px;
      }
    }
  }


</style>
